import React from 'react';
import { Modal, Button, Space, Typography } from 'antd';
import { FileOutlined, CheckOutlined, CloseOutlined } from '@ant-design/icons';

const { Text } = Typography;

const FileReceiver = ({ fileOffer, onAccept, onReject }) => {
  if (!fileOffer) return null;

  const { from, fileInfo } = fileOffer;
  const fileSizeKB = Math.round(fileInfo.size / 1024);

  return (
    <Modal
      title="Incoming File"
      open={true}
      onCancel={onReject}
      footer={[
        <Button key="reject" onClick={onReject} icon={<CloseOutlined />}>
          Reject
        </Button>,
        <Button key="accept" type="primary" onClick={onAccept} icon={<CheckOutlined />}>
          Accept
        </Button>
      ]}
    >
      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
        <div style={{ textAlign: 'center' }}>
          <FileOutlined style={{ fontSize: '48px', color: '#1890ff' }} />
        </div>
        
        <div>
          <Text strong>From: </Text>
          <Text>{from.slice(0, 12)}...</Text>
        </div>
        
        <div>
          <Text strong>File: </Text>
          <Text>{fileInfo.name}</Text>
        </div>
        
        <div>
          <Text strong>Size: </Text>
          <Text>{fileSizeKB} KB</Text>
        </div>
        
        <div>
          <Text strong>Type: </Text>
          <Text>{fileInfo.type}</Text>
        </div>
      </Space>
    </Modal>
  );
};

export default FileReceiver;